import React from 'react';
import { observer, inject } from 'mobx-react';
import {
  Grid,
  withStyles,
  Typography,
  Table,
  TableHead,
  TableBody,
  TableCell,
  TableRow,
  Paper,
  Menu,
  MenuItem,
  FormControl,
  TextField,
  Button,
} from '@material-ui/core';
// import PageTitleBar from '../../components/PageTitleBar/PageTitleBar';
import PageTitle from '../../components/PageTitle/PageTitle';
import IconButton from '@material-ui/core/IconButton';
import * as Icons from '@material-ui/icons';
import Swal from 'sweetalert2';
import { notification } from 'antd';
import Loader from '../../components/Loader/LoaderView';
import { withTranslation } from 'react-i18next';
import SummaryReportPage from '../summaryReport/SummaryReportPage';
import CustomFooter from '../../components/Table/CustomFooter';
import moment from 'moment';
import config from '../../config';
import Setting from '../../components/Dialog/SettingView';
import Devices from '../../components/Dialog/DevicesView';
import Patient from '../../components/Dialog/PatientView';
import ContactPerson from '../../components/Dialog/ContactPersonView';
import Movement from '../../components/Dialog/MovementView';
import CreateAccount from '../../components/Dialog/CreateAccountView';
import StatusView from '../../components/Dialog/StatusView';
import ManageGarminAccount from '../../components/Dialog/ManageGarminAccountView';
import SelectTenant from '../../components/Select/SelectTenant';
import '../../App.css';
import { tenantInfo } from '../../utils/tenantInformation';
import { setSelectTenant } from '../../utils/common';

class AllPatients extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      tenant: 0,
      dialogStatus: {
        id: null,
        open: false,
      },
      dialogActivities: {
        id: null,
        open: false,
      },
      dialogSetting: {
        id: null,
        open: false,
      },
      dialogPatient: {
        id: null,
        open: false,
        bedInfo: null,
      },
      dialogDevice: {
        id: null,
        open: false,
      },
      dialogContact: {
        id: null,
        open: false,
        readOnly: false,
      },
      dialogMovement: {
        id: null,
        open: false,
      },
      dialogCreateAccount: {
        id: null,
        open: false,
      },
      dialogGarminAccount: {
        id: null,
        open: false,
      },
      movement: {
        id: 0,
      },
      viewMore: {
        open: false,
      },
      data: {
        search: false,
        name: '',
        patient: {
          hn: '',
          firstname: '',
          lastname: '',
          gender: 'M',
          dob: '0000-00-00',
        },
      },
      lastSync: null,
      search: '',
      isMoreMenuOpen: null,
      patientData: '',
      anchorEl: null,
    };
  }

  async componentDidMount() {
    this.props.nirun.getLastSyncTime();
    const { offset, limit, search, sort, order, action, tenantIds } = this.props.patient.toJS();
    if (action) {
      this.setState({
        tenant: tenantIds && tenantIds.length > 0 ? JSON.stringify(tenantIds) : 0,
      });
      await this.props.patient.getAllPatients(offset, limit, search, sort, order, tenantIds);
      this.props.patient.setAction('action', null);
    } else {
      const tenantIds = localStorage.getItem('select_tenant') ? [+localStorage.getItem('select_tenant')] : null;
      this.setState({
        tenant: tenantIds ? JSON.stringify(tenantIds) : 0,
      });

      this.props.patient.resetData();
      await this.props.patient.setPaginationForAllPatients('tenantIds', tenantIds);
      // await this.props.patient.getAllPatients();
    }
  }

  formatDate(input) {
    // eslint-disable-next-line
    var regex_date = /^\d{4}\-\d{1,2}\-\d{1,2}$/;
    if (regex_date.test(input)) {
      const datePart = input.match(/\d+/g),
        year = +datePart[0] + 543, // get only two digits
        month = datePart[1],
        day = datePart[2];
      return day + '/' + month + '/' + year;
    } else {
      return input;
    }
  }

  initDataPatient = async (patient = null) => {
    if (patient) {
      let { data } = this.state;
      data.patient.dob = this.formatDate(data.patient.dob);
      this.props.patient.setData(data);
      this.props.patient.setHnStatus(true);
    } else {
      this.props.patient.setData({
        search: false,
        name: '',
        patient: {
          hn: '',
          firstname: '',
          lastname: '',
          firstnameEn: '',
          lastnameEn: '',
          gender: 'M',
          dob: '00/00/0000',
        },
      });
      await this.props.patient.setHnStatus(true);
    }
  };

  setMoreMenuOpen = async (event, patient) => {
    this.setState({
      isMoreMenuOpen: event.currentTarget,
      patientData: patient,
      data: { patient },
    });
  };

  setMoreMenuClose = () => {
    this.setState({
      isMoreMenuOpen: null,
    });
  };

  handleChangeTenant = async (event) => {
    const { name, value } = event.target;
    this.setState({
      [name]: value,
      viewMore: {
        open: false,
      },
    });
    const tenantIds = JSON.parse(value);
    await this.props.patient.setPaginationForAllPatients('tenantIds', tenantIds);
    setSelectTenant(tenantIds);
  };

  handleCloseDialog = () => {
    this.setState({
      dialogActivities: { open: false, id: null },
      dialogSetting: { open: false, id: null },
      dialogGarminAccount: { open: false, id: null },
      dialogPatient: { open: false, id: null, bedInfo: null },
      dialogDevice: { open: false, id: null },
      dialogContact: { open: false, id: null, readOnly: false },
      dialogMovement: { open: false, id: null },
      dialogCreateAccount: { open: false, id: null },
    });
  };

  handleClickOpenDialogEditPatient = async (patient) => {
    await this.initDataPatient(patient);
    this.setState({
      dialogPatient: { open: true, id: patient.id, bedInfo: null },
      isMoreMenuOpen: null,
    });
  };

  handleClickOpenDialogContact = async (patient, readOnly = false) => {
    try {
      await this.initDataPatient(patient);
      const contactPersons = await this.props.contactperson.findContactPersonByPatientId(patient.id);
      this.props.contactperson.setContactData(contactPersons);
      this.setState({
        dialogContact: {
          open: true,
          id: !readOnly ? patient.id : null,
          readOnly,
        },
        isMoreMenuOpen: null,
      });
    } catch (err) {
      notification.error({
        message: `error`,
        description: err.error.message,
        top: '100px',
      });
    }
  };

  handleClickOpenDialogManageDevice = async (patient) => {
    try {
      // await this.initDataPatient(patient);
      this.props.patient.clearSelectDevice();
      this.props.deviceType.setAction('category', null);
      await this.props.deviceType.getCategory();

      this.setState({
        dialogDevice: { open: true, id: patient.id },
        isMoreMenuOpen: null,
      });
    } catch (err) {
      if (err.statusCode === 401) {
        this.signOut();
        window.location.replace('/login');
      } else {
        notification.error({
          message: `error`,
          description: err.error.message,
          top: '100px',
        });
      }
    }
  };

  handleClickOpenDialogAlertSetting = async (patient) => {
    try {
      await this.props.area.getAreas();
      await this.props.settingProfile.getSettingProfile(0, 0);
      await this.props.setting.getSettingByPatient(patient.id);
      this.setState({
        dialogSetting: { open: true, id: patient.id },
        isMoreMenuOpen: null,
      });
    } catch (err) {
      if (err.statusCode === 401) {
        this.signOut();
        window.location.replace('/login');
      } else {
        notification.error({
          message: `error`,
          description: err.error.message,
          top: '100px',
        });
      }
    }
  };

  handleClickOpenDialogManageGarminAccount = async (patient) => {
    try {
      const queryOption = {
        patient: true,
        device: true,
        tenantIds: patient && patient.tenantId ? JSON.stringify([patient.tenantId]) : null,
      };
      await this.props.smartwatch.getAllAccounts(queryOption);
      await this.props.smartwatch.getAccountByPatientId(patient.id);
      this.setState({
        dialogGarminAccount: { open: true, id: patient.id },
        isMoreMenuOpen: null,
      });
    } catch (err) {
      if (err.statusCode === 401) {
        this.signOut();
        window.location.replace('/login');
      } else {
        notification.error({
          message: `error`,
          description: err.error.message,
          top: '100px',
        });
      }
    }
  };

  handleClickDischagePatient = async (patient) => {
    const { t } = this.props;
    Swal.fire({
      html:
        patient.devices.length > 0
          ? `<h4>${t('discharge_patient')}<h4>${t('discharge_patient2')}`
          : `<h4>${t('sure_to_discharge')}`,
      type: 'warning',
      confirmButtonText: `${t('discharge')}`,
      cancelButtonText: `${t('close')}`,
      showCancelButton: true,
      reverseButtons: true,
      customClass: {
        container: 'my-swal',
      },
    }).then(async (result) => {
      if (result.value) {
        this.setState({ isMoreMenuOpen: null });
        try {
          const bed = await this.props.dashboard.getBedByPatient(patient.id);
          if (patient.devices.length > 0) {
            for (const data of patient.devices) {
              await this.props.device.unAssignDeviceToPatient(data.id, data.serial);
            }
            this.clearAlert(bed);
          }
          await this.props.dashboard.discharge(bed, true);

          // automatically delete bed if module type is 'home'
          if ((localStorage.getItem('subgroup_type') || 'hospital') === 'home') {
            await this.props.dashboard.deleteBedPermanently(bed.id);
            // await this.props.dashboard.getPatientForSubgroup(
            //   localStorage.getItem("select_module"),
            //   false
            // );
          }

          // re load page
          const { offset, limit, search, sort, order } = this.props.patient.toJS();
          await this.props.patient.getAllPatients(offset, limit, search, sort, order);
        } catch (err) {
          if (err.statusCode === 401) {
            this.signOut();
            window.location.replace('/login');
          } else {
            notification.error({
              message: `error`,
              description: err.error.message,
              top: '100px',
            });
          }
        }
      }
    });
  };

  handleClickOpenDialogCreateAccount = async (patient) => {
    await this.props.user.getUserPatient(patient && patient.id);
    this.setState({
      dialogCreateAccount: {
        open: true,
        id: patient && patient.id ? patient.id : null,
      },
      isMoreMenuOpen: null,
    });
  };

  handleClickMovement = async (patient) => {
    await this.initDataPatient(patient);
    this.setState({
      dialogMovement: { open: true, id: patient.id },
      isMoreMenuOpen: null,
    });
  };

  handleClickOpenDialogActivities = async (patient) => {
    try {
      if (patient) {
        this.props.vitalsign.resetVitalSigns();
        this.props.summary.resetSummary(true);
        await this.props.summary.getGraphAvailableDate(patient.id);
        this.props.summary.getVitalSignDate(patient.id);
        this.props.summary.getAssignedDeviceDate(patient.id);
        config.features.report.garmin && this.props.summary.getGarminDate(patient.id);

        let queryOption = {};
        if (localStorage.getItem('role_id') === '1') {
          queryOption = {
            activity: true,
            movement: true,
            alert: true,
            location: true,
            battery: true,
            admin: true,
            device: true,
          };
        } else {
          queryOption = {
            activity: true,
            movement: true,
            location: true,
          };
        }

        this.props.summary.getSummary(patient.id, new Date(), queryOption);
        const { since } = this.props.vitalsign.toJS();

        const queryLastVitalsign = {
          heartrate: true,
          temperature: true,
          bloodPressure: true,
          spo2: true,
          respirationRate: true,
        };

        const querySummaryVitalsign = {
          heartrate: true,
          temperature: true,
          bloodPressure: true,
          spo2: true,
          respirationRate: true,
          since,
        };

        this.props.summary.getSummaryReport(patient.id, new Date());
        this.props.summary.getSummaryReportAsPeriod(patient.id, new Date(), 'week', ['sleep', 'event']);
        this.props.summary.getSummaryLocationAsPeriod(patient.id, new Date(), 'week');
        this.props.vitalsign.getLastVitalSign(patient.id, new Date(), queryLastVitalsign);
        this.props.vitalsign.getSummaryVitalSign(patient.id, new Date(), querySummaryVitalsign);
        config.features.report.garmin &&
          this.props.smartwatchsummary.summaryVitalSigns(patient.id, new Date(), 'daily', [
            'heartrate',
            'spo2',
            'respiration',
          ]);
        this.setState({
          dialogActivities: { open: true, id: patient.id },
          isMoreMenuOpen: null,
        });
      }
    } catch (err) {
      console.log(err);
      throw err;
    }
  };

  async chageActivate(patient) {
    let device = patient.devices;
    device.map((val) => {
      val.status = val.status === 'ACTIVATE_ON' ? 'ACTIVATE_OFF' : 'ACTIVATE_ON';
      return val;
    });
    try {
      await this.props.dashboard.assignDevice(device, patient.id);
    } catch (err) {
      notification.error({
        message: `error`,
        description: err.error.message,
        top: '100px',
      });
    }
  }

  hasReport(devices, reportType) {
    const found = devices.filter((d) => {
      if (!d.deviceVersion) {
        return false;
      }
      const deviceProperty = d.deviceVersion['property'] ? JSON.parse(d.deviceVersion['property']) : null;
      if (deviceProperty) {
        return deviceProperty[reportType] === 1;
      }

      return false;
    });
    return found.length > 0;
  }

  getCurrentAssignedDevice = (devices) => {
    return {
      assignedDevices: devices && devices.length > 0 ? devices.map((v) => v.name) : [],
      reportOptions: {
        hasActivity: devices && devices.length > 0 ? this.hasReport(devices, 'motionTracker') : true,
        hasLocalization: devices && devices.length > 0 ? this.hasReport(devices, 'localization') : true,
      },
    };
  };

  getGender = (gender) => {
    const { t } = this.props;
    let result = '';
    switch (gender) {
      case 'F':
        result = <div>{t('female')}</div>;
        break;
      case 'M':
        result = <div>{t('male')}</div>;
        break;
      default:
        break;
    }
    return result;
  };

  getPatientStatus = (data) => {
    const { t } = this.props;
    const status = data ? data.toUpperCase() : null;
    let result = '';
    switch (status) {
      case 'ADMITTED':
        result = <div>{t('admitted_status')}</div>;
        break;
      case 'DISCHARGED':
        result = <div>{t('discharged_status')}</div>;
        break;
      default:
        break;
    }
    return result;
  };

  handleChangeRowsPerPage = (value) => {
    this.props.patient.setPaginationForAllPatients('limit', value);
  };

  handlechangePage = (value) => {
    const { limit } = this.props.patient.toJS();
    this.props.patient.setPaginationForAllPatients('offset', value * limit);
  };

  handleSyncWithNirun = async () => {
    this.setState({
      viewMore: {
        open: false,
      },
    });

    const { tenant } = this.state;
    const syncTenant = +tenant === 0 ? [] : JSON.parse(tenant);
    await this.props.nirun.syncPatient(syncTenant);

    await this.props.nirun.getLastSyncTime();
    const { offset, limit, search, sort, order, tenantIds } = this.props.patient.toJS();
    await this.props.patient.getAllPatients(offset, limit, search, sort, order, tenantIds);
  };

  handleOpenTime = () => {
    this.setState({
      viewMore: {
        open: !this.state.viewMore.open,
      },
    });
  };

  syncNirunButton() {
    const { classes, t } = this.props;
    const { viewMore } = this.state;
    const { loading, nirunLastSyncTime } = this.props.nirun.toJS();
    const timeDatas = this.getsyncTime(nirunLastSyncTime);
    return (
      <div className={classes.wrapSync}>
        <Button
          variant='outlined'
          color='primary'
          className={classes.button}
          id='createDeviceButton'
          onClick={this.handleSyncWithNirun}
        >
          <Icons.Sync className={`${classes.icon} ${loading ? 'App-logo' : ''}`} />
          {t('sync_with_nirun')}
        </Button>
        {timeDatas.length > 1 ? (
          <div className={classes.lastSync}>
            {t('updated_on')}{' '}
            <div className={classes.viewMore} onClick={this.handleOpenTime}>
              {t('view_all')}
            </div>
          </div>
        ) : (
          <div className={classes.lastSync}>
            {t('updated_on')} {timeDatas.length === 1 ? timeDatas[0].lastDateSync : '-'}
          </div>
        )}
        {viewMore.open && (
          <div className={classes.viewMoreBox}>
            {timeDatas.map((t) => (
              <div className={classes.viewMoreContent} key={t.id}>
                <Grid container item xs={5} sm={5}>
                  {t.lastDateSync}
                </Grid>
                <Grid container item xs={7} sm={7} className={classes.alignText}>
                  {t.name}
                </Grid>
              </div>
            ))}
          </div>
        )}
      </div>
    );
  }

  getsyncTime(nirunLastSyncTime) {
    let tenantsInfo = [];
    const tenants = tenantInfo();
    nirunLastSyncTime &&
      Object.entries(nirunLastSyncTime).forEach(([key, value]) => {
        let data = tenants
          .filter((t) => t.id === +key)
          .map((d) => {
            d.lastDateSync = moment(new Date(value)).format('DD/MM/YYYY HH:mm');
            return d;
          });

        tenantsInfo = tenantsInfo.concat(data);
      });

    const { tenant } = this.state;
    const syncTenant = tenant === 0 ? [] : JSON.parse(tenant);
    if (syncTenant.length > 0) {
      tenantsInfo = tenantsInfo.filter((t) => syncTenant.includes(t.id));
    }

    return tenantsInfo;
  }

  titleContent() {
    const { classes, t } = this.props;
    const { search } = this.props.patient.toJS();
    return (
      <div className={classes.titleBar}>
        <SelectTenant handleChangeTenant={this.handleChangeTenant} tenant={this.state.tenant} />
        <Grid className={classes.search}>
          <FormControl variant='outlined' className={classes.formControl} fullWidth>
            <TextField
              variant='outlined'
              size='small'
              value={search || ''}
              name='search'
              id='search'
              className={classes.contentInput}
              placeholder={t('search')}
              onChange={(e) => this.handleChangeSearch(e)}
            ></TextField>
          </FormControl>
        </Grid>
      </div>
    );
  }

  handleChangeSearch = (event) => {
    const { value } = event.target;
    this.props.patient.setPaginationForAllPatients('offset', 0, false);
    this.props.patient.setPaginationForAllPatients('search', value);
  };

  render() {
    const { classes, t } = this.props;
    const { patientData, isMoreMenuOpen } = this.state;
    const nirun = this.props.nirun.toJS();
    let { allPatients, loading, limit } = this.props.patient.toJS();
    const page = allPatients.data ? allPatients.pagination.page - 1 : 0;
    const count = allPatients.data ? allPatients.pagination.count : 0;

    (allPatients.data || []).map((item) => {
      let fullname = '';
      if (localStorage.getItem('i18nextLng') === 'th-TH') {
        if (item.firstname || item.lastname) {
          fullname = `${item.firstname ?? ''} ${item.lastname ?? ''}`;
        } else {
          fullname = `${item.firstnameEn ?? ''} ${item.lastnameEn ?? ''}`;
        }
      }
      if (localStorage.getItem('i18nextLng') === 'en-EN') {
        if (item.firstnameEn || item.lastnameEn) {
          fullname = `${item.firstnameEn ?? ''} ${item.lastnameEn ?? ''}`;
        } else {
          fullname = `${item.firstname ?? ''} ${item.lastname ?? ''}`;
        }
      }

      item.fullname = fullname;

      if (item.dob) {
        const dateDob = new Date(item.dob);
        const formattedDob = `${dateDob.getFullYear()}-${('0' + (dateDob.getMonth() + 1)).slice(
          -2,
        )}-${('0' + dateDob.getDate()).slice(-2)}`;
        item.age = moment(new Date()).diff(formattedDob, 'years');
      } else {
        item.age = '';
      }
      return item;
    });

    // const showActivateButton =
    //   patientData &&
    //   patientData.devices &&
    //   patientData.devices
    //     .map((value) => (value.deviceVersion ? JSON.parse(value.deviceVersion.property).activateButton : 0))
    //     .some((value) => value);

    // const showAlertSetting = patientData && patientData.devices && patientData.devices.length > 0;

    return (
      <React.Fragment>
        <Loader loading={loading || nirun.loading} />
        <PageTitle title={t('all_patients')} button={config.features.allPatients.syncNirun && this.syncNirunButton()}>
          {this.titleContent()}
        </PageTitle>
        {/* <PageTitleBar
          title={t("all_patients")}
          button={config.features.allPatients.syncNirun && t("sync_with_nirun")}
          icon={<Icons.Sync className={classes.icon} />}
        >
          <div className={classes.selectTenant}>
           <SelectTenant handleChangeTenant={this.handleChangeTenant} tenant={this.state.tenant}/>
          </div> */}

        {/* <Grid container item xs={12}>
          <Grid container item xs={2} sm={2}>
              {" "}
              <div>
                {" "}
                {t("all_patients")} {count}
              </div>
            </Grid>
            <Grid container item xs={10} sm={10}>
              {" "}
              <hr className={classes.divider} />{" "}
            </Grid>
          </Grid> */}
        {/* <Grid container item xs={12}>
            <Grid container item xs={5} sm={5}>
              <FormControl
                variant="outlined"
                className={classes.formControl}
                fullWidth
              >
                <TextField
                  variant="outlined"
                  size="small"
                  value={this.state.search}
                  name="search"
                  id="search"
                  className={classes.contentInput}
                  placeholder={t("search")}
                  onChange={(e) => this.handleChangeSearch(e)}
                ></TextField>
              </FormControl>
            </Grid>
            <Grid container item xs={7} sm={7}>
              <div
                style={{
                  display: "flex",
                  marginLeft: 30,
                  marginTop: 10,
                }}
              >
                <Typography
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  แสดงผลสถานะตามผู้ป่วย:{" "}
                </Typography>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    marginLeft: 15,
                  }}
                >
                  <Checkbox
                    edge="start"
                    checked={true}
                    value="admitted"
                    id="admitted"
                    color="primary"
                    tabIndex={-1}
                    disableRipple
                  />
                  <div>{t("admitted_status")}</div>
                  <Checkbox
                    edge="start"
                    checked={true}
                    value="discharged"
                    id="discharged"
                    color="primary"
                    tabIndex={-1}
                    disableRipple
                  />
                  <div>{t("discharged_status")}</div>
                </div>
              </div>
            </Grid>
          </Grid> */}
        {/* </PageTitleBar> */}
        <Grid container spacing={32} className={classes.mainContain}>
          <Grid item xs={12}>
            <Paper className={classes.paperList}>
              <Table aria-label='simple table'>
                <TableHead>
                  <TableRow className={classes.headTable}>
                    <TableCell className={classes.tableCell} />
                    <TableCell className={classes.tableCell} align='left'>
                      HN
                    </TableCell>
                    <TableCell className={classes.tableCell} align='left'>
                      {t('name')}
                    </TableCell>
                    <TableCell className={classes.tableCell} align='left'>
                      {t('gender')}
                    </TableCell>
                    <TableCell className={classes.tableCell} align='left'>
                      {t('age')} ({t('years')})
                    </TableCell>
                    <TableCell className={classes.tableCell} align='left'>
                      {t('status')}
                    </TableCell>
                    <TableCell className={classes.tableCell} align='left'>
                      {t('location')} ({config.configType ? t('group') : t('module')})
                    </TableCell>
                    <TableCell className={classes.tableCell} align='left'>
                      {t('tenant')}
                    </TableCell>
                    <TableCell className={classes.tableCell} />
                  </TableRow>
                </TableHead>
                <TableBody>
                  {(allPatients.data || []).map((data, i) => (
                    <TableRow key={i} className={classes.bodyTable}>
                      <TableCell className={classes.tableCell} />
                      <TableCell className={classes.tableCell} align='left'>
                        {data.hn}
                      </TableCell>
                      <TableCell className={classes.tableCell} align='left'>
                        {data.fullname}
                      </TableCell>
                      <TableCell className={classes.tableCell} align='left'>
                        {this.getGender(data.gender)}
                      </TableCell>
                      <TableCell className={classes.tableCell} align='left'>
                        {data.age}
                      </TableCell>
                      <TableCell className={classes.tableCell} align='left'>
                        {this.getPatientStatus(data.status)}
                      </TableCell>
                      <TableCell className={classes.tableCell} align='left'>
                        {data.subgroup ? data.subgroup.name : ''}
                      </TableCell>
                      <TableCell className={classes.tableCell} align='left'>
                        {data.tenant ? data.tenant.name : ''}
                      </TableCell>
                      <TableCell className={classes.tableCell}>
                        <IconButton
                          className={classes.butttonOption}
                          aria-owns='more-menu'
                          aria-haspopup='true'
                          onClick={(e) => this.setMoreMenuOpen(e, data)}
                        >
                          <svg viewBox='0 0 26 26' width='24'>
                            <use xlinkHref={`/images/menus-v1.svg#moremenus`} />
                          </svg>
                        </IconButton>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
              <div className={classes.footerTable}>
                <CustomFooter
                  count={count}
                  page={page}
                  rowsPerPage={limit}
                  changeRowsPerPage={this.handleChangeRowsPerPage}
                  changePage={this.handlechangePage}
                  rowsPerPageOptions={[10, 15, 50]}
                />
              </div>
            </Paper>
          </Grid>
        </Grid>
        {patientData && patientData.id && (
          <Menu
            id='more-menu'
            open={Boolean(isMoreMenuOpen)}
            anchorEl={isMoreMenuOpen}
            onClose={this.setMoreMenuClose}
            disableAutoFocusItem
          >
            {/* {showActivateButton && (
              <div>
                <MenuItem onClick={() => this.chageActivate(patientData)}>
                  <Typography>
                    {(patientData.devices.length > 0 &&
                      patientData.devices[0].status) === "ACTIVATE_ON"
                      ? t("off")
                      : t("on")}
                  </Typography>
                </MenuItem>
                <hr className={classes.dialogMenu} />
              </div>
            )} */}

            {/* <MenuItem
              onClick={() =>
                this.handleClickOpenDialogManageDevice(patientData)
              }
            >
              <Typography>{t("manage_devices")}</Typography>
            </MenuItem> */}

            {/* <MenuItem
              onClick={() =>
                this.handleClickOpenDialogAlertSetting(patientData)
              }
              disabled={showAlertSetting ? false : true}
            >
              <Typography>{t("alert_setting")}</Typography>
            </MenuItem> */}
            {/* <hr className={classes.dialogMenu} /> */}
            {/* {config.features.report.garmin && (
              <MenuItem
                onClick={() =>
                  this.handleClickOpenDialogManageGarminAccount(patientData)
                }
              >
                <Typography>{t("manage_garmin_account")}</Typography>
              </MenuItem>
            )} */}
            <MenuItem onClick={() => this.handleClickOpenDialogCreateAccount(patientData)}>
              <Typography>{t('manage_myactsense_account')}</Typography>
            </MenuItem>
            <hr className={classes.dialogMenu} />

            <MenuItem
              onClick={() => this.handleClickOpenDialogEditPatient(patientData)}
              // disabled={config.features.allPatients.syncNirun}
            >
              <Typography>{t('edit_patient')}</Typography>
            </MenuItem>

            <MenuItem
              onClick={() => this.handleClickOpenDialogContact(patientData)}
              // disabled={config.features.allPatients.syncNirun}
            >
              <Typography>{t('edit_contact_info')}</Typography>
            </MenuItem>

            {/* <MenuItem onClick={() => this.handleClickMovement(patientData)}>
              <Typography>{t("move_patient")}</Typography>
            </MenuItem> */}
            {/* <MenuItem
              onClick={() => this.handleClickDischagePatient(patientData)}
              disabled
            >
              <Typography>{t("discharge")}</Typography>
            </MenuItem> */}
            <hr className={classes.dialogMenu} />

            <MenuItem onClick={() => this.handleClickOpenDialogActivities(patientData)}>
              <Typography>{t('summary_report')}</Typography>
            </MenuItem>
          </Menu>
        )}
        {this.state.dialogActivities.open && (
          <SummaryReportPage
            open={this.state.dialogActivities.open}
            handleClose={this.handleCloseDialog}
            data={this.state.data}
            currentAssignedDevice={this.getCurrentAssignedDevice(this.state.data.patient.devices)}
          />
        )}
        {this.state.dialogSetting.open && (
          <Setting
            props={this.props}
            patientData={patientData}
            state={this.state}
            handleClose={this.handleCloseDialog}
          />
        )}
        {this.state.dialogDevice.open && (
          <Devices
            props={this.props}
            patientData={this.state.data}
            state={this.state}
            handleClose={this.handleCloseDialog}
          />
        )}
        {this.state.dialogPatient.open && (
          <Patient
            props={this.props}
            dataBed={this.state.data}
            state={this.state}
            handleClose={this.handleCloseDialog}
            onlyUpdate={true}
          />
        )}
        {this.state.dialogContact.open && (
          <ContactPerson
            props={this.props}
            patient={patientData}
            readOnly={this.state.dialogContact.readOnly}
            state={this.state}
            handleClose={this.handleCloseDialog}
          />
        )}
        {this.state.dialogMovement.open && (
          <Movement
            props={this.props}
            dataBed={this.state.data}
            patientData={this.state.patientData}
            state={this.state}
            handleClose={this.handleCloseDialog}
          />
        )}
        {this.state.dialogCreateAccount.open && (
          <CreateAccount
            props={this.props}
            patientData={this.state.patientData}
            state={this.state}
            handleClose={this.handleCloseDialog}
          />
        )}
        {this.state.dialogStatus.open && (
          <StatusView
            open={this.state.dialogStatus.open}
            // data={findDataStatue}
            setCloseStatus={this.setCloseStatus}
          />
        )}
        {this.state.dialogGarminAccount.open && (
          <ManageGarminAccount
            open={this.state.dialogGarminAccount.open}
            patientData={this.state.patientData}
            handleClose={this.handleCloseDialog}
            pathName={this.props.location.pathname}
          />
        )}
      </React.Fragment>
    );
  }
}

const styles = (theme) => ({
  mainContain: {
    marginTop: '5px',
    padding: 16,
    // width: "100%",
    // padding: "5px 5px 0px 40px",
  },
  icon: {
    color: theme.palette.success.main,
  },
  divider: {
    backgroundColor: 'rgba(9,30,66,0.13)',
    border: 0,
    height: '1px',
    margin: '10px 0px 10px 0',
    padding: 0,
    right: 8,
    width: '100%',
  },
  paperList: {
    overflowX: 'auto',
    padding: '10px 20px',
  },
  headTable: {
    border: 'none',
  },
  tableCell: {
    color: theme.palette.text.header,
    borderBottom: '1px solid #B8CFC3',
    padding: '4px',
  },
  bodyTable: {
    borderTop: '1px solid #B8CFC3',
  },
  footerTable: {
    display: 'flex',
    justifyContent: 'end',
  },
  butttonOption: {
    padding: '3px',
    margin: 2,
    color: theme.palette.success.main,
    backgroundColor: theme.palette.primary.bg,
    width: 26,
    height: 26,
    '&:hover': {
      backgroundColor: theme.palette.primary.hover,
    },
  },
  root: {
    padding: '2px 4px',
    display: 'flex',
    alignItems: 'center',
    width: 400,
  },
  formInput: {
    padding: theme.spacing.unit * 2,
    textAlign: 'center',
    '& label': {
      transform: 'translate(0px, 7px) scale(0.7) !important',
      fontSize: '1.33rem !important',
      width: 'max-content',
    },
  },
  textfield: {
    '& fieldset': {
      top: '4px',
      bottom: '6px',
    },
    '& input': {
      marginLeft: '-2px',
    },
    '& label': {
      marginLeft: '2px',
    },
    width: '100%',
    minWidth: 145,
    paddingRight: '12px',
    paddingLeft: '4px',
  },
  input: {
    paddingBottom: '7px',
  },
  positionPaper: {
    position: 'relative',
    marginTop: '-10px',
    zIndex: 1400,
  },
  patientMenuItem: {
    width: '100%',
    maxHeight: 200,
    overflow: 'auto',
  },
  RadioGroup: {
    marginTop: '-12px',
  },
  selectTenant: {
    width: '80%',
    marginLeft: -theme.spacing.unit * 6,
  },
  formControl: {
    '& .MuiInputLabel-shrink': {
      transform: 'translate(14px, 10px) scale(1)',
    },
    margin: theme.spacing.unit / 2,
    width: '100%',
    marginLeft: theme.spacing.unit * 2,
  },
  contentInput: {
    '& fieldset': {
      top: '2px',
    },
    '& input': {
      paddingTop: '17px',
      paddingBottom: '9px',
    },
  },
  titleBar: {
    display: 'flex',
    marginTop: '-5px',
  },
  search: {
    width: '300px',
    [theme.breakpoints.down('sm')]: {
      width: '250px',
    },
  },
  wrapSync: {
    marginTop: '-4px',
    marginBottom: '-4px',
    position: 'relative',
    width: '100%',
    textAlign: 'right',
  },
  lastSync: {
    fontSize: 13,
    display: 'flex',
    justifyContent: 'end',
  },
  viewMore: {
    color: theme.palette.success.main,
    fontWeight: 500,
    textDecoration: 'underline',
    cursor: 'pointer',
    marginLeft: 10,
  },
  viewMoreBox: {
    zIndex: 1,
    position: 'absolute',
    backgroundColor: 'white',
    padding: 8,
    borderRadius: 2,
    boxShadow: theme.customShadows.widget,
    right: 0,
  },
  viewMoreContent: {
    fontSize: 13,
    display: 'flex',
  },
  alignText: {
    textAlign: 'left',
  },
  button: {
    border: '1px solid #B8CFC3',
    color: theme.palette.text.primary,
    '&:hover': {
      backgroundColor: theme.palette.background.green,
      border: '1px solid #B8CFC3',
      color: 'white',
    },
    '&:hover $icon': {
      color: 'white',
    },
  },
});

export const page = inject(
  'patient',
  'event',
  'device',
  'deviceType',
  'dashboard',
  'bed',
  'setting',
  'summary',
  'vitalsign',
  'setting',
  'settingProfile',
  'area',
  'contactperson',
  'smartwatch',
  'smartwatchsummary',
  'user',
  'nirun',
)(observer(AllPatients));
export const translation = withTranslation()(page);
export default withStyles(styles, { withTheme: true })(translation);
